import { defineStore } from 'pinia'
import { sortByProperty } from '@utils/array'

const DESKTOP_PAYMENT_METHODS = ['stripe', 'paypal', 'manual']

export const usePremiumStore = defineStore('premium', {
    state: () => ({
        plans: [],
        subscriptions: [],
        selectedPlanId: null,
        currentTransaction: null,
        isLoading: true,
        hasLoadedSubscriptions: false,
    }),
    getters: {
        activeSubscription(state) {
            const currentSubscription = state.subscriptions.reduce((latest, current) => {
                if (!latest) return current
                return new Date(current.endTime) > new Date(latest.endTime) ? current : latest
            }, null)

            if (!currentSubscription) return null

            if (new Date(currentSubscription.endTime) < new Date()) return null

            const currentPlan = state.plans.find(
                plan => plan.id === currentSubscription.subscriptionsProductsId.id
            )
            currentSubscription.plan = currentPlan
            return currentSubscription
        },
        currentSubscription() {
            return this.activeSubscription || this.freeSubscription
        },
        freeSubscription(state) {
            return { plan: state.plans.find(plan => plan.price === 0) }
        },
        hasEverBeenPremium(state) {
            return state.subscriptions.length > 0
        },
        isPremium() {
            return !!this.activeSubscription
        },
        // Only a subscriptions answer that actually arrived can say "not Premium" —
        // a failed boot call leaves `subscriptions` empty, which is not the same thing.
        isKnownNotPremium() {
            return this.hasLoadedSubscriptions && !this.isPremium
        },
        sortedPremiumPlans(state) {
            return sortByProperty({ array: [...state.plans], property: 'price', direction: 'desc' })
                .filter(plan => plan.price > 0)
        },
        selectedPlan(state) {
            return state.plans.find(plan => plan.id === Number(state.selectedPlanId))
        },
        paymentMethod(state) {
            return state.currentTransaction?.paymentProcessor
        },
        hasPaidViaMobile() {
            return this.activeSubscription && !DESKTOP_PAYMENT_METHODS.includes(this.paymentMethod)
        },
    },
    actions: {
        setPlans(plans) {
            this.plans = plans
        },

        setSubscriptions(subscriptions) {
            this.subscriptions = subscriptions
            this.hasLoadedSubscriptions = true
        },

        setSelectedPlanId(planId) {
            this.selectedPlanId = planId
        },

        setActiveTransaction(transaction) {
            this.currentTransaction = transaction
        },

        setIsLoading(isLoading) {
            this.isLoading = isLoading
        },
    },
})
